'use client';
import { Modal } from "react-bootstrap";
import { SlClose } from "react-icons/sl";
import '../JobBoard.css';

const JobInfoModel = ({ isOpen, onRequestClose }) => {
    return (
        <Modal
            className="Job_info-modal"
            show={isOpen}
            onHide={onRequestClose}
            centered
            size="xl"
        >
            <div className="Job_Info_container">
                <div className="clearBtn" id="JobInfoModalClose" onClick={onRequestClose}>
                    <SlClose />
                </div>

                <h4 id="JobInfoModalTitle">Important Information</h4>
                <div className="section-content" id="JobInfoModalContent">
                    <h6>1. How to Apply for Jobs</h6>
                    <p>
                        The application process depends on the link provided by the job source.
                        <br />First, search for the relevant jobs and click on the <strong>“Apply”</strong> button.
                        You will then be redirected to the original job posting, where you will find the
                        complete details and instructions on how to submit your application.
                        <br />If the <strong>“Apply”</strong> button is <strong>not visible</strong>, it means that we did
                        not receive an active application link in the API response.
                        In this scenario, you will need to perform a manual search: take the <strong>Job Title</strong> and
                        <strong> Company Name</strong> from our listing and search for them on Google.
                        This will lead you to the official job posting on the employer’s website where you can complete your application.
                    </p>

                    <h6>2. How to Use Our Job Listings</h6>
                    <p>
                        We aim to make your job search as efficient as possible. To begin, use the search bar to
                        enter the most accurate and specific term for the role you’re seeking
                        (e.g., “engineer” or “nurse”). Once you’ve entered the job title, click on the
                        <strong> “Find jobs”</strong> button. A list of all vacancies matching your query will be displayed.
                        <br />You can then refine your search results by further specifying the professional field you are looking for.
                        Please use the filtering options located on the right-hand side, such as selecting a specific
                        <strong> Job Category</strong> from the drop-down menu to narrow your focus.
                        <br />The job listings are updated every hour to ensure you see the most current opportunities,
                        and we show the latest jobs first by default. You can also sort the search results by
                        relevance of your search term within the job advertisement or by publication date
                        (for immediacy of vacancies).
                    </p>

                    <h6>3. Where Do Our Job Listings Come From?</h6>
                    <p>
                        Our job board aggregates vacancies from several reliable sources to provide you with a wide range of opportunities.
                        The primary source for our listings is the official job board (<strong>Jobsuche</strong>) of the
                        Federal Employment Agency (<strong>Bundesagentur für Arbeit – BA</strong>).
                        We also integrate jobs from the <strong>Adzuna Jobs API</strong>, which are filtered specifically
                        for opportunities in Bavaria and Munich, and we source specialized tech roles from the
                        <strong> ArbeitNow Jobs API</strong>.
                    </p>
                    <p>
                        <strong>Important Note on Language:</strong><br />
                        Please note that the job vacancies are listed in the language in which employers originally submitted them to the BA.
                        Currently, the majority of the job vacancies are listed in German.
                    </p>

                    <p><strong>We wish you the best of luck for a successful job search!</strong></p>
                </div>
            </div>
        </Modal>
    );
};

export default JobInfoModel;
